import React, { Component } from 'react';
import store from '../../store';
import { ShowPagination, GetPageParameter } from '../../component/ShowPagination';
import { HandleSubmit } from '../../func/HandleSubmit';
import Autocomplete from 'react-autocomplete';
import '../../component/AutoComplete.css'
import { matchStateToTerm, sortStates } from '../../component/AutoCompleteFunc'
import matchSorter from 'match-sorter'

import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import ReactToPrint from "react-to-print";
import Select from 'react-select';
var RowInPageParam = 20
//let reftable = React.createRef;
let ref1;
class InventoryKala extends Component {

    reqest_number = "";
    constructor(props) {
        super(props);
        this.state = {
            TableOfInventory: [],
            SearchItems: [],
            TableRow: [],
            Loading: true,
            SubPage: this.props.subpage,
            SelectPage: 0,
            RowInPage: RowInPageParam,
            InventoryCounter: 0,
            value: '',
            PageChangetable: 0,
            PageSizetable: 20,
            Filtertable: [],
            Sorttable: [],

            fields: {
                Name: [],
                Pressure: [],
                Type1: [],
                Size: [],
                Type2: []
            },
            SendParameters: {
                kala_name: { kala_name: '' },
                limit: RowInPageParam,
                offset: 0,/////request per page
            }
        };
        //this.GetTableOfInventory = this.GetTableOfInventory.bind(this);
        // this.GetTableOfInventoryByName = this.GetTableOfInventoryByName.bind(this);
        //this.GetHeaderOfTableOfInventory = this.GetHeaderOfTableOfInventory.bind(this);
        //this.SetParameterValue = this.SetParameterValue.bind(this);
        this.InitParameter = this.InitParameter.bind(this);
        // this.GetKalaName = this.GetKalaName.bind(this);
        // this.SetParameterValueByName = this.SetParameterValueByName.bind(this);
        // this.CreateRow = this.CreateRow.bind(this);

    }
    // async SetParameterValueByName(name, value) {
    //     this.state.SendParameters['kala_name'] = { ...this.state.SendParameters['kala_name'], [name]: value };
    //     this.setState({
    //         SendParameters: this.state.SendParameters,
    //     });
    //     // console.log("qqq", this.state.SendParameters);
    // }
    // async GetKalaName() {
    //     this.setState({
    //         Loading: true
    //     });
    //     var response_info = await HandleSubmit('getdata/getkalaname', '');
    //     this.setState({
    //         SearchItems: (response_info),
    //     });
    //     this.setState({
    //         Loading: false
    //     });
    // }

    async GetTableOfInventoryByName() {
        this.setState({
            Loading: true
        });
        var response = await HandleSubmit('getdata/gettableofkalainventorybyname', this.state.SendParameters);
        this.setState({
            TableOfInventory: (response).items,
            InventoryCounter: (response).record_count
        });
        //await this.CreateRow();
        this.setState({
            Loading: false
        });
    }
    // async GetTableOfSumInventoryByName() {
    //     this.setState({
    //         Loading: true
    //     });
    //     var response = await HandleSubmit('getdata/gettableofkalainventorybyname', this.state.SendParameters);
    //     this.setState({
    //         TableOfInventory: (response).items,
    //         InventoryCounter: (response).record_count
    //     });
    //     await this.CreateRow();
    //     this.setState({
    //         Loading: false
    //     });
    // }
    // async HandlePagination() {
    //     var PageNumber = GetPageParameter();
    //     this.state.SendParameters.limit = this.state.RowInPage;
    //     this.state.SendParameters.offset = (PageNumber * this.state.RowInPage);
    //     this.setState({
    //         SendParameters: this.state.SendParameters,
    //         SelectPage: PageNumber
    //     });
    //     await this.GetTableOfInventoryByName();
    //     //console.log("limit", this.state.SendParameters.limit);
    //     //console.log("offset", this.state.SendParameters.offset);
    // }
    // async CreateRow() {
    //     this.setState({
    //         TableRow: [],
    //     });
    //     var PageNumber = GetPageParameter();
    //     var startindex = PageNumber * this.state.RowInPage;
    //     for (let item of this.state.TableOfInventory) {
    //         //console.log(item);

    //         this.state.TableRow.push({
    //             Row: <React.Fragment>
    //                 <td>{item.row + startindex}</td>
    //                 <td>{item.kala_code}</td>
    //                 <td>{item.kala_name}</td>
    //                 <td>{item.anbar}</td>
    //                 <td>{item.kala_inventory_free}</td>
    //                 <td>{item.kala_inventory_stock}</td>
    //             </React.Fragment>
    //         });
    //     }
    //     this.setState({
    //         TableRow: this.state.TableRow,
    //     });
    // }
    handleSearchPress = (event) => {
        if (event.key == 'Enter') {
            this.InitParameter()
        }
    }
    async InitParameter() {
        this.state.SendParameters.limit = this.state.RowInPage;
        this.state.SendParameters.offset = 0;
        this.setState({
            SelectPage: 0,
            SendParameters: this.state.SendParameters,
        });
        await this.GetTableOfInventoryByName();

    }
    async componentDidMount() {
        //await this.GetTableOfInventoryByName();
        store.dispatch({ type: 'root' });
        // console.log(store.getState());
        // await this.GetKalaName();
        await this.InitParameter();
    }

    componentWillReceiveProps() {
        this.setState({
            SubPage: this.props.subpage
        });

    }
    render() {
        //if (this.state.Loading === true) return(<div>Loading....</div>)
        switch (this.state.SubPage) {
            case 'main': {
                return (
                    <div>
                        {(this.state.Loading === true) ? (<div>در حال بارگزاری.....</div>) :
                            <div>
                                <ReactTable
                                    className="-striped -highlight"
                                    filterable
                                    //onPageSizeChange={(e) =>  this.setState({ PageSizetable: e })}
                                    onPageSizeChange={(e) => this.setState({ PageSizetable: e })}
                                    onPageChange={(e) => this.setState({ PageChangetable: e })}
                                    onSortedChange={(e) => this.setState({ Sorttable: e })}
                                    onFilteredChange={(e) => this.setState({ Filtertable: e })}

                                    headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                                    data={this.state.TableOfInventory}
                                    //filterable
                                    columns={[
                                        {
                                            Header: "#",
                                            accessor: "row",
                                            maxWidth: 100,
                                            minWidth: 20
                                        },
                                        {
                                            Header: () => <div style={{ fontWeight: "bold" }}> کد کالا </div>,
                                            //Header:()=><h1>Name</h1>,
                                            accessor: "kala_code",
                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, {threshold: matchSorter.rankings.CONTAINS ,keys: ["kala_code"] }),
                                            filterAll: true
                                        },
                                        {
                                            Header: () => <div style={{ fontWeight: "bold" }}> نام کالا </div>,
                                            //Header: " نام کالا",
                                            accessor: "kala_name",

                                            filterMethod: (filter, rows) =>
                                                matchSorter(rows, filter.value, { keys: ["kala_name"] }),
                                            filterAll: true
                                            // filterMethod: (filter, row) => (
                                            //     row[filter.id].startsWith(filter.value) && row[filter.id].endsWith(filter.value)),

                                            // accessor: d => d.lastName

                                        },
                                        {
                                            Header: () => <div style={{ fontWeight: "bold" }}>انبار </div>,
                                            accessor: "anbar",
                                            Filter: ({ filter, onChange }) =>
                                                <select
                                                    onChange={event => onChange(event.target.value)}
                                                    style={{ width: "100%" }}
                                                    value={filter ? filter.value : "all"}
                                                >
                                                    <option value="">نمایش همه</option>
                                                    <option value="انبار ورامین">انبار ورامین</option>
                                                    <option value="انبار فیروزآباد">انبار فیروزآباد</option>
                                                </select>
                                        },
                                        {
                                            Header: () => <div style={{ fontWeight: "bold" }}>موجودی انبار </div>,
                                            accessor: "kala_inventory_stock"
                                        }
                                    ]}
                                    defaultPageSize={20}
                                    className="-striped -highlight"

                                />
                                <br />
                            </div>}
                        <div hidden="true">
                            <PrintDetailView
                                ref={el => (this.PrintDetailRef = el)}
                                TableOfInventory={this.state.TableOfInventory}
                                Sorttable={this.state.Sorttable}
                                PageChangetable={this.state.PageChangetable}
                                PageSizetable={this.state.PageSizetable}
                                Filtertable={this.state.Filtertable}
                            />
                        </div>
                        <ReactToPrint
                            trigger={() => <button className="btn btn-outline-warning" >Print</button>}
                            content={() => this.PrintDetailRef}
                        />
                    </div>
                );
                break;
            }
            default: {
                return null;
            }
        }
    }
}
export default (InventoryKala);

class PrintDetailView extends Component {
    laboo = this.props.PageSizetable;
    constructor(props) {
        super(props);
        this.state = {
            TableOfInventory: this.props.TableOfInventory,

        }
    }
    componentDidUpdate() {

    }

    render() {
        // let count=(parseInt((this.props.TableOfInventory.length) / 5) + 1) * 5;

        return (
            <React.Fragment>
                <ReactTable
                    style={{ direction: "rtl", textAlign: "center", fontSize: "15px" }}
                    data={this.props.TableOfInventory}
                    showPagination={false}
                    pageSize={this.props.PageSizetable}
                    defaultSorted={this.props.Sorttable}
                    page={this.props.PageChangetable}
                    defaultFiltered={this.props.Filtertable}
                    columns={[
                        {
                            Header: "",
                            accessor: "test",
                            width: 100
                        },
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 20
                        },
                        {
                            //Header: "کد کالا ",
                            Header: () => <div style={{ fontWeight: "bold" }}> کد کالا </div>,
                            accessor: "kala_code",
                        },
                        {
                            Header: " نام کالا",
                            accessor: "kala_name",
                            width: 250
                        },
                        {
                            Header: " انبار",
                            accessor: "anbar",
                            Filter: ({ filter, onChange }) =>
                                <select
                                    onChange={event => onChange(event.target.value)}
                                    style={{ width: "100%" }}
                                    value={filter ? filter.value : "all"}
                                >
                                    <option value="">نمایش همه</option>
                                    <option value="انبار ورامین">انبار ورامین</option>
                                    <option value="انبار فیروزآباد">انبار فیروزآباد</option>
                                </select>
                        },
                        {
                            Header: "موجودی انبار",
                            accessor: "kala_inventory_stock"
                        },
                        {
                            Header: "",
                            accessor: "test",
                            width: 100
                        }
                    ]}
                    // defaultPageSize={15}
                    className="-striped -highlight"
                    ref={(ref) => ref1 = ref}
                />
                <h1>Page {this.props.PageChangetable + 1}</h1>
            </React.Fragment>

        )
    }
}





// WEBPACK FOOTER //
// ./src/pages/Kala/InventoryKala.js